import api from "./api";

const BASE = "/service";

function path(resource, id = "", action = "") {
  const suffix = id ? `/${encodeURIComponent(id)}` : "";
  return `${BASE}/${resource}${suffix}${action ? `/${action}` : ""}`;
}

export async function listMasterData(resource, params = {}) {
  const { data } = await api.get(path(resource), { params });
  return data;
}

export async function createMasterData(resource, payload) {
  const { data } = await api.post(path(resource), payload);
  return data;
}

export async function updateMasterData(resource, id, payload) {
  const { data } = await api.patch(path(resource, id), payload);
  return data;
}

export async function setMasterDataActive(resource, id, isActive) {
  const { data } = await api.post(path(resource, id, isActive ? "activate" : "deactivate"));
  return data;
}
